import { render, staticRenderFns } from "./faq-tab.vue?vue&type=template&id=f22142e0"
import script from "./faq-tab.vue?vue&type=script&lang=js"
export * from "./faq-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports